"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeBorderRadii = void 0;
var mergeBorderRadii = function (baseRadii, overrideRadii) {
    var hasRoundedCorners = overrideRadii.primary == null || overrideRadii.primary > 0;
    return hasRoundedCorners
        ? baseRadii
        : {
            small: 0,
            medium: 0,
            large: 0,
            control: 0,
        };
};
exports.mergeBorderRadii = mergeBorderRadii;
//# sourceMappingURL=mergeBorderRadii.js.map